'use strict';

function getErrorBlock(opts) {
  return {
    tag: 'span',
    attrs: {
      className: {
        'help-block': true,
        'error-block': opts.hasError
      }
    },
    children: opts.error
  };
}

module.exports = getErrorBlock;




/*****************
 ** WEBPACK FOOTER
 ** ./~/uvdom-bootstrap/lib/getErrorBlock.js
 ** module id = 1066
 ** module chunks = 0
 **/